<template>
  <div>
    <b-modal
      id="deleteFinanceModal"
      :title="`${$t('billing_finance.delete')}`"
      no-close-on-esc
      no-close-on-backdrop
      ref="deleteFinanceModal"
      size="sm"
    >
      <div>
        <p>{{ $t("billing_finance.delete_question") }}</p>
        <p class="text-danger">
          {{ totalList }} {{ $t("billing_finance.delete_description") }}
        </p>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="onClose" :disabled="isDeleting">
          {{
            $t("actions.cancel").charAt(0).toUpperCase() + $t("actions.cancel").slice(1)
          }}
        </b-button>
        <b-button @click="onDelete" variant="success" :disabled="isDeleting">
          <b-spinner small v-if="isDeleting"></b-spinner>
          <span v-else>
            {{ $t("actions.delete") }}
          </span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    totalList: {
      type: Number,
      default: 0,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onClose = () => {
      emit("close");
    };

    const onDelete = () => {
      emit("delete");
    };

    return {
      onClose,
      onDelete,
    };
  },
};
</script>

